<div mat-dialog-title><mat-icon class="title align-middle">group</mat-icon>{{ dialogTitle | translate:locale.language }}</div>
<div mat-dialog-content>
  <ng-container *ngIf="group; else loading">
    <div id="group-name" class="row-item" *ngIf="group.name">
      <span class="summary-label"><mat-icon>group</mat-icon>{{ 'Name' | translate:locale.language}}:</span>
      <div>{{ group.name }}</div>
    </div>
    <div id="group-type" class="row-item" *ngIf="group.classification">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ 'Type' | translate:locale.language}}:</span>
      <div>{{ group.classification }}</div>
    </div>
    <div id="group-link" class="row-item" *ngIf="group.isLinked">
      <span class="summary-label"><mat-icon>link</mat-icon>{{ 'Linked' | translate:locale.language}}:</span>
      <div>Yes</div>
    </div>
    <div id="group-children" class="row-item">
      <span class="summary-label"><mat-icon>groups</mat-icon>{{ 'Child Groups' | translate:locale.language}}:</span>
      <div>{{ !!group.children ? group.children : ('None' | translate:locale.language) }}</div>
    </div>
    <div id="group-members" class="row-item">
      <span class="summary-label"><mat-icon>contacts</mat-icon>{{ 'Members' | translate:locale.language}}:</span>
      <div>{{ !!group.members ? group.members : ('None' | translate:locale.language) }}</div>
    </div>
    <div id="group-total-members" class="row-item" *ngIf="!!group.children">
      <span class="summary-label" matTooltip="{{ 'includes nested group members' | translate:locale.language }}">
        <mat-icon>contacts</mat-icon>{{ 'Total Members' | translate:locale.language}}:
      </span>
      <div *ngIf="!!contacts; else loading">{{ contacts?.totalItemCount }}</div>
      <ng-template #loading><app-loading [isInline]="true" [diameter]="22"></app-loading></ng-template>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="row">
      <app-loading [hasFailed]="!!loadError" [failTitle]="loadError" [hideRetry]="hideRetry" (retryClicked)="loadGroup()"></app-loading>
    </div>
  </ng-template>
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" id="closeGroup" (click)="closeDialogs()">{{ 'Close' | translate:locale.language }}</button>
</div>